import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import React from 'react'
import { useEventTracking } from '../../helpers/gtmHelper'
import { n_classroom } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { COLORS } from '../../modules/vars'

type GoogleTranslateBtnPropsType = {
  setShowGoogleTranslate: any
  showGoogleTranslate: any
  customTxtColor?: any
  customSize?: any
  customBorderColor?: any
  className?: string
}

const GoogleTranslateBtn: React.FC<GoogleTranslateBtnPropsType> = ({
  setShowGoogleTranslate,
  showGoogleTranslate,
  customSize,
  customTxtColor,
  customBorderColor,
  className = '',
}) => {
  const { t } = useTranslation()
  const { sendClickEvent } = useEventTracking()
  return (
    <DSButton
      size={customSize ? customSize : BUTTON_SIZE.SM}
      type={BUTTON_TYPE.OUTLINE}
      onClick={() => {
        sendClickEvent({ button_name: 'lesson_translate' })
        setShowGoogleTranslate(!showGoogleTranslate)
      }}
      customBorderColor={customBorderColor ? customBorderColor : COLORS.PURPLE600}
      className={className}
    >
      <DSButton.Label customTxtColor={customTxtColor ? customTxtColor : COLORS.PURPLE600}>
        {t(n_classroom.google_translator_title)}
      </DSButton.Label>
    </DSButton>
  )
}

export default GoogleTranslateBtn
